/**
 * Format a list of strings as "A, B, and C" (or "A et B" in FR).
 * Pass the conjunction word from i18n so it's locale-aware.
 */
export const formatNaturalList = (
  names: string[],
  conjunction: string = 'and'
): string => {
  if (names.length === 0) return '';
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} ${conjunction} ${names[1]}`;
  return `${names.slice(0, -1).join(', ')}, ${conjunction} ${names[names.length - 1]}`;
};
